import {MISSING_AUTH_ERROR, USER_FIELDS} from '../constants';

import {readAuthData} from './auth-storage';

export const addAuthParams = (urlParams: URLSearchParams): URLSearchParams => {
  const values = readAuthData()?.values;

  if (!values) throw new Error(MISSING_AUTH_ERROR);

  const {link_account, zip_code} = values;

  urlParams.set(USER_FIELDS.LINK_ACCOUNT, link_account);
  urlParams.set(USER_FIELDS.ZIP_CODE, zip_code);

  return urlParams;
};
